import { render, staticRenderFns } from "./personalAreaPdf.vue?vue&type=template&id=6fa304a5&scoped=true&"
import script from "./personalAreaPdf.vue?vue&type=script&lang=js&"
export * from "./personalAreaPdf.vue?vue&type=script&lang=js&"
import style0 from "./personalAreaPdf.vue?vue&type=style&index=0&id=6fa304a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa304a5",
  null
  
)

export default component.exports